Array.from(document.querySelectorAll("#featured-product")).forEach((featuredProd) => {
  const upsellCheckbox = featuredProd.querySelector("[data-upsell-checkbox]");
  const bonusCard = featuredProd.querySelector(".product__bonus");
  const originalPrice = bonusCard.dataset.originalPrice;
  const discountedPrice = bonusCard.dataset.discountedPrice;
  const discount = bonusCard.dataset.discount;
  const bonusCardPrice = bonusCard.querySelector("[data-bonus-price]");
  const bonusAddText = bonusCard.querySelector("[data-bonus-add-text]")
  upsellCheckbox.addEventListener("change", () => bonusCard.classList.toggle("checked", this.checked))
  
  document.addEventListener("variant:change", function(e) {
    const variant = e.detail;
    const lessThanRequired = variant.title.includes("Single");
    bonusCard.querySelector("[data-bonus-old-price]").classList.toggle("hidden", lessThanRequired);
    bonusCardPrice.classList.toggle("discounted", !lessThanRequired);
    bonusCardPrice.innerText = lessThanRequired ? originalPrice : discountedPrice;
    let remainingNumber;
    if (variant.title.includes("Sing")) remainingNumber = "1 more slide";
    bonusAddText.innerText = lessThanRequired ?  "Add " + remainingNumber + " to get " + discount + "% off" : "";
    bonusCard.querySelector("[data-bonus-sale-tag]").classList.toggle("hidden", lessThanRequired)
  })
})